// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ASnQ","clinicsSelect":"styles_clinicsSelect__1Xdq0"};